import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

const navigation = [
  { name: "Expertise", href: "/services" },
  { name: "About Trey", href: "/about" },
  { name: "Signal for Families", href: "/signal" },
  { name: "Lab", href: "/projects" },
];

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return (
    <header className="border-b border-stone-300/80">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:bg-white focus:p-4"
      >
        Skip to content
      </a>
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 py-6 sm:px-8 lg:px-12"
        aria-label="Main navigation"
      >
        <Link
          to="/"
          className="flex shrink-0 items-center gap-3"
          aria-label="Polity Interfaces home"
        >
          <img src="/logo.png" alt="" width="36" height="36" className="h-9 w-9" />
          <span className="text-lg font-medium tracking-tight">Polity Interfaces</span>
        </Link>
        <div className="hidden items-center gap-8 lg:flex">
          {navigation.map((item) =>
            item.href === "/signal" ? (
              <a
                key={item.href}
                href={item.href}
                className="text-sm text-stone-600 hover:text-teal-800"
              >
                {item.name}
              </a>
            ) : (
              <NavLink
                key={item.href}
                to={item.href}
                className={({ isActive }) =>
                  `text-sm ${isActive ? "font-medium text-teal-800 underline underline-offset-8" : "text-stone-600 hover:text-teal-800"}`
                }
              >
                {item.name}
              </NavLink>
            )
          )}
          <Link to="/contact" className="text-link text-sm">
            Let’s talk <span aria-hidden="true">↗</span>
          </Link>
        </div>
        <button
          type="button"
          onClick={() => setMobileMenuOpen(true)}
          className="-m-2 p-2 lg:hidden"
          aria-label="Open navigation"
          aria-expanded={mobileMenuOpen}
        >
          <Bars3Icon className="h-6 w-6" aria-hidden="true" />
        </button>
      </nav>
      <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="relative z-50 lg:hidden">
        <div className="fixed inset-0 bg-black/20" aria-hidden="true" />
        <DialogPanel className="fixed inset-y-0 right-0 w-full max-w-sm overflow-y-auto bg-[#f7f6f2] p-6 shadow-xl">
          <div className="flex items-center justify-between">
            <DialogTitle className="text-lg font-medium">Polity Interfaces</DialogTitle>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2 p-2"
              aria-label="Close navigation"
            >
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <nav className="mt-10 flex flex-col gap-7" aria-label="Mobile navigation">
            {[
              { name: "Home", href: "/" },
              ...navigation,
              { name: "Let’s talk", href: "/contact" },
            ].map((item) =>
              item.href === "/signal" ? (
                <a key={item.href} href={item.href} className="text-xl hover:text-teal-800">
                  {item.name}
                </a>
              ) : (
                <NavLink
                  key={item.href}
                  to={item.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-xl hover:text-teal-800"
                >
                  {item.name}
                </NavLink>
              )
            )}
          </nav>
        </DialogPanel>
      </Dialog>
    </header>
  );
}
